import { render, staticRenderFns } from "./DatosAbonosSGAComponent.vue?vue&type=template&id=1823580a"
import script from "./DatosAbonosSGAComponent.vue?vue&type=script&lang=js"
export * from "./DatosAbonosSGAComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports